import { render } from "./ViewSingle.vue?vue&type=template&id=888112de&scoped=true"
import script from "./ViewSingle.vue?vue&type=script&lang=js"
export * from "./ViewSingle.vue?vue&type=script&lang=js"

import "./ViewSingle.vue?vue&type=style&index=0&id=888112de&scoped=true&lang=css"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-888112de"]])

export default __exports__